import { API_ROOT, PAYPAL_API_KEY } from '../../constants';

export const NAME = 'paypal';

export const PAY_URL = `${API_ROOT}/public/payment-solution/paypal/pay`;
export const CAPTURE_URL = `${API_ROOT}/public/payment-solution/paypal/confirm`;
export const DETAILS_URL = `${API_ROOT}/payment-solution/paypal/%orderId%/details`;

export const PAYPAL_OPTIONS = {
    clientId: PAYPAL_API_KEY,
    'enable-funding': 'venmo',
    'disable-funding': 'paylater,card',
    'data-sdk-integration-source': 'integrationbuilder_sc',
    currency: 'EUR'
};

export const REQUEST_PAYPAL_DETAILS = 'REQUEST_PAYPAL_DETAILS';
export const SUCCESS_PAYPAL_DETAILS = 'SUCCESS_PAYPAL_DETAILS';
export const FAILURE_PAYPAL_DETAILS = 'FAILURE_PAYPAL_DETAILS';



// WEBPACK FOOTER //
// ./src/services/paypal/constants.js